module.exports = __webpack_public_path__ + "media/images/emblems/Saint-George-coat_of_arms-58729d67e7a0af678942102879fbe19d.svg";